import { HeaderNavItem } from '@/components/nav/header';
import { useLayoutContext } from '@/contexts';
import { Flex, Title } from '@mantine/core';
import {
	IconBell,
	IconChecklist,
	IconCodeCircle,
	IconHistory,
	IconLuggage,
	IconStar,
	IconTrophy,
	IconUser,
	IconWallet,
} from '@tabler/icons-react';
import { ComponentProps } from 'react';
import { TopNavFor } from './constants';
import styles from './styles.module.css';

interface Props {
	forPage: TopNavFor;
}

type TopNavSet = {
	navs: ComponentProps<typeof HeaderNavItem>[];
	title: string;
};

const navSets: Record<TopNavFor, TopNavSet> = {
	[TopNavFor.ACCOUNT]: {
		navs: [
			{ to: '/account', label: 'My Profile', icon: IconUser },
			{ to: '/scan-history', label: 'Scan History', icon: IconHistory },
			{ to: '/billing', label: 'Billing', icon: IconWallet },
			{ to: '/alerts', label: 'Alerts', icon: IconBell },
		],
		title: 'Account',
	},
	[TopNavFor.ENTRIES_AND_REWARDS]: {
		navs: [
			{ to: '/rewards', label: 'My Entries', icon: IconTrophy },
			{ to: '/past-winners', label: 'Past Winners', icon: IconStar },
		],
		title: 'Rewards',
	},
	[TopNavFor.FACILITY_SCAN_HISTORY]: {
		navs: [
			{ to: '/facility/history', label: 'Bale Scans', icon: IconCodeCircle },
			{ to: '/facility/history-bag', label: 'Bag Scans', icon: IconLuggage },
			{ to: '/facility/history-audit', label: 'Audit', icon: IconChecklist },
		],
		title: 'Scan History',
	},
};

export const TopNav = (props: Props) => {
	const { forPage } = props;
	const { isDesktop } = useLayoutContext();
	const navSet = navSets[forPage];
	return (
		<Flex
			w="100%"
			className={styles.root}
			gap="sm"
			px={isDesktop ? 'xl' : 'lg'}
			align="center"
			justify="space-between"
		>
			<>
				{isDesktop && (
					<Title order={2} fw={700}>
						{navSet.title}
					</Title>
				)}
				<Flex gap="sm">
					{navSet.navs.map((nav) => (
						<HeaderNavItem key={nav.to} {...nav} />
					))}
				</Flex>
			</>
		</Flex>
	);
};
